import { apiUrl } from '../content/landingContent.js'

// Documento legal vigente, do mesmo endpoint público que o app usa nas
// páginas /termos e /privacidade (backend src/routes/public.js). Sem
// autenticação — mesmo padrão de fetchPlans.js, devolvendo null no erro pra
// o modal decidir o que exibir.
export async function fetchLegalDocument(documentType) {
  try {
    const res = await fetch(`${apiUrl}/api/public/legal-documents/current?document_type=${documentType}`)
    if (!res.ok) return null
    const json = await res.json()
    return json.data || null
  } catch {
    return null
  }
}
